import { generateMutations } from '../builder'

export default {
  ...generateMutations('getCharacterAges', 'characterAges'),
}
